import { IDecisionListFilter } from '../interfaces/IDecisionListFilter';

export const initialDecisionListFilter: IDecisionListFilter = {
  name: 'Новый фильтр',
  years: [],
  ignoreKno: false,
  includeChildKno: true,
  includeDomainChild: false,
  includeChildProsecutorOrg: true,
};
